import styled from 'styled-components';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default styled(LazyLoadImage)`
    display: block;
    width: 100%;
    height: 100%;
`;
